import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center">
      <XCircle size={64} className="mx-auto text-slate-500" />
      <h1 className="font-head font-black text-3xl mt-5 text-slate-50">Checkout cancelled</h1>
      <p className="text-slate-400 mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
      <Button onClick={() => navigate("/pricing")} className="mt-6 bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold rounded-xl h-11 px-8">
        Back to Pricing
      </Button>
    </div>
  );
}
